import { type FC } from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export const EmptyState: FC<EmptyStateProps> = ({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  onAction,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 text-center ${className}`} role="status">
      <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-background-100 border border-background-200/70 mb-5">
        <i className={`${icon} text-3xl text-foreground-400`} />
      </div>
      <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{title}</h3>
      {description && (
        <p className="text-sm text-foreground-500 max-w-sm mb-5">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-lg transition-colors duration-150 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-add-line text-lg" />
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;